"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const community_1 = require("@aurora/shared-types/community");
const NextContextHelper_1 = __importDefault(require("@aurora/shared-client/helpers/NextContextHelper"));
const asynchronous_local_storage_1 = require("asynchronous-local-storage");
const exenv_1 = require("exenv");
const log_1 = require("../log");
const log = (0, log_1.getLog)(module);
/**
 * A holder for parent-frame id.
 */
class ParentFrameSupplier {
    /**
     * Sets the global parent frame ID on the client and on the httpContext (request) on the server.
     * @param parentFrameId
     */
    static setParentFrameId(parentFrameId) {
        if (parentFrameId) {
            log.trace('Setting parent frame id %s', parentFrameId);
            if (exenv_1.canUseDOM) {
                globalThis.parentFrameId = parentFrameId;
            }
            else {
                asynchronous_local_storage_1.als.set(community_1.ContextKeys.parentFrameId, parentFrameId);
            }
        }
    }
    /**
     * Gets the global parent frame ID on the client and from the httpContext (request) on the server.
     */
    static getParentFrameId() {
        if (exenv_1.canUseDOM) {
            if (!globalThis.parentFrameId) {
                const { parentFrameId } = (0, NextContextHelper_1.default)();
                log.trace('Initializing frame id %s', parentFrameId);
                globalThis.parentFrameId = parentFrameId;
            }
            else {
                log.trace('Parent frame id %s', globalThis.parentFrameId);
            }
            return globalThis.parentFrameId;
        }
        else {
            return asynchronous_local_storage_1.als.get(community_1.ContextKeys.parentFrameId);
        }
    }
}
exports.default = ParentFrameSupplier;
//# sourceMappingURL=ParentFrameSupplier.js.map